export const styleFirstHead = {
  backgroundColor: "#c8102e",
  color: "#ffffff",
  textAlign: "center",
  fontWeight: 600,
  fontSize: 15,
  padding: "12px 16px",
  border: "none",
};

export const styleSecondHead = {
  backgroundColor: "#fef2f2",
  color: "#111827",
  textAlign: "center",
  fontWeight: 600,
  fontSize: 12,
  padding: "10px 8px",
  border: "none",
};

export const styleThirdHead = {
  backgroundColor: "#f9fafb",
  color: "#374151",
  textAlign: "center",
  fontWeight: 600,
  fontSize: 11,
  padding: "8px 6px",
  border: "none",
  lineHeight: 1.35,
};

export const styleFooter = {
  backgroundColor: "#f3f4f6",
  color: "#111827",
  textAlign: "center",
  fontWeight: 700,
  fontSize: 12,
  padding: "10px 8px",
  border: "none",
};
